var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 56,
    viewBox: "0 0 184 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9899 9.74573H79.005V12.6988H70.5516V16.1252H78.1484V19.0783H70.5516V22.5723H79.253V25.5254H66.9899V9.74573ZM80.9429 9.74573H94.1302V12.7664H89.3062V25.5254H85.7445V12.7664H80.9429V9.74573ZM96.4878 9.74573H100.05V16.3281H107.195V9.74573H110.757V25.5254H107.195V19.3037H100.05V25.5254H96.4878V9.74573ZM77.3819 35.2542C75.7138 34.2623 73.7301 33.6312 72.4677 33.6312C71.273 33.6312 70.4614 34.0595 70.4614 34.9161C70.4614 37.824 78.8697 36.201 78.8472 41.8817C78.8472 44.97 76.1647 46.6381 72.6706 46.6381C70.0782 46.6381 67.4858 45.6462 65.705 44.1359L67.1252 41.2279C68.7482 42.6706 71.0475 43.5949 72.7157 43.5949C74.1809 43.5949 75.0601 43.0539 75.0601 42.0845C75.0601 39.109 66.6518 40.8447 66.6518 35.2542C66.6518 32.3913 69.1089 30.5879 72.7608 30.5879C74.9699 30.5879 77.1791 31.2642 78.757 32.3012L77.3819 35.2542ZM89.5034 34.2623C92.231 34.2623 93.9668 36.0657 93.9668 38.9061V46.5254H90.4953V39.9205C90.4953 38.3876 89.5936 37.4408 88.1058 37.4408C86.37 37.4634 85.3105 38.7708 85.3105 40.5517V46.5254H81.839V29.799H85.3105V36.5391C86.1671 35.0288 87.6098 34.2849 89.5034 34.2623ZM102.596 34.2849C106.857 34.2849 108.84 37.1027 108.547 41.521H99.8459C100.252 43.0539 101.424 43.9556 102.979 43.9556C104.129 43.9556 105.211 43.5047 106.045 42.6706L107.871 44.5191C106.654 45.8717 104.873 46.6606 102.686 46.6606C98.809 46.6606 96.3519 44.181 96.3519 40.5066C96.3519 36.7645 98.8992 34.2849 102.596 34.2849ZM99.7783 39.4696H105.301C105.256 37.8691 104.219 36.8322 102.619 36.8322C101.086 36.8322 100.049 37.8691 99.7783 39.4696ZM118.955 34.2623C121.66 34.2623 123.395 36.0657 123.395 38.9061V46.5254H119.924V39.9205C119.924 38.3876 119.022 37.4408 117.534 37.4408C115.799 37.4634 114.762 38.7708 114.762 40.5517V46.5254H111.29V34.3976H114.762V36.5166C115.618 35.0062 117.061 34.2849 118.955 34.2623ZM126.125 34.4201H136.471V36.6067L130.227 43.7978H136.674V46.5479L125.899 46.5254V44.3388L132.143 37.1478L126.125 37.1252V34.4201ZM147.288 34.2623C150.016 34.2623 151.752 36.0657 151.752 38.9061V46.5254H148.28V39.9205C148.28 38.3876 147.379 37.4408 145.891 37.4408C144.155 37.4634 143.096 38.7708 143.096 40.5517V46.5254H139.624V29.799H143.096V36.5391C143.952 35.0288 145.395 34.2849 147.288 34.2623ZM160.381 34.2849C164.642 34.2849 166.625 37.1027 166.332 41.521H157.631C158.037 43.0539 159.209 43.9556 160.764 43.9556C161.914 43.9556 162.996 43.5047 163.83 42.6706L165.656 44.5191C164.439 45.8717 162.658 46.6606 160.471 46.6606C156.594 46.6606 154.137 44.181 154.137 40.5066C154.137 36.7645 156.684 34.2849 160.381 34.2849ZM157.563 39.4696H163.086C163.041 37.8691 162.004 36.8322 160.404 36.8322C158.871 36.8322 157.834 37.8691 157.563 39.4696ZM176.74 34.2623C179.445 34.2623 181.181 36.0657 181.181 38.9061V46.5254H177.709V39.9205C177.709 38.3876 176.807 37.4408 175.32 37.4408C173.584 37.4634 172.547 38.7708 172.547 40.5517V46.5254H169.075V34.3976H172.547V36.5166C173.403 35.0062 174.846 34.2849 176.74 34.2623Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_552_7076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3305 28.8898L27.9999 10.0847L16.6694 28.8898L27.9999 47.6949L39.3305 28.8898Z",
    fill: "url(#paint0_linear_552_7076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 47.6949V10.0847L39.3304 28.8898L27.9999 47.6949Z",
    fill: "url(#paint1_linear_552_7076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3728 28.8898L28 24.4407L18.6271 28.8898L28 33.339L37.3728 28.8898Z",
    fill: "#2D2042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.161 28.8897L27.9999 26.4575L22.8389 28.8897L27.9999 31.3219L33.161 28.8897Z",
    fill: "url(#paint2_linear_552_7076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 28C56 43.4831 43.483 56 28 56C21.7118 56 15.9576 53.9238 11.2712 50.4831C7.29658 47.517 4.21184 43.5424 2.25421 38.9746L4.09319 36.9577L5.04235 35.8899C8.30506 45.3814 17.322 52.2627 28 52.2627C39.5678 52.2627 49.2373 44.1949 51.6695 33.339L47.2796 28.8899L53.1525 23.4916L55.2881 21.5339C55.7034 23.6102 56 25.7458 56 28Z",
    fill: "url(#paint3_linear_552_7076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5169 19.0424L52.5 20.8814L51.4322 21.8898C48.7627 11.4492 39.2712 3.73729 28 3.73729C15.7797 3.73729 5.69491 12.7542 4.0339 24.5L8.77966 28.8898L4.38983 33.339L3.26271 34.4068L1.24576 36.4237C0.474576 33.7542 0 30.9068 0 28C0 12.5169 12.5169 0 28 0C30.2542 0 32.4491 0.237288 34.5847 0.771186C43.8983 3.02542 51.4322 9.9661 54.5169 19.0424Z",
    fill: "url(#paint4_linear_552_7076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33043 33.3389L3.26264 34.4067C2.72874 32.3304 2.43213 30.1948 2.43213 27.9999C2.43213 13.8813 13.8813 2.49146 27.9406 2.49146C39.5677 2.49146 49.3559 10.2626 52.4406 20.8813L51.3728 21.8898C48.7626 11.4491 39.2711 3.73722 27.9999 3.73722C15.7796 3.73722 5.69484 12.7542 4.03382 24.4999L8.77959 28.8898L4.33043 33.3389Z",
    fill: "url(#paint5_linear_552_7076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5084 27.9999C53.5084 42.1186 42.0592 53.5084 27.9999 53.5084C17.0253 53.5084 7.71178 46.627 4.09314 36.8982L5.04229 35.8304C8.305 45.3813 17.3219 52.2626 27.9999 52.2626C39.5677 52.2626 49.2372 44.1948 51.6694 33.3389L47.2796 28.8898L53.1525 23.4915C53.3897 24.9152 53.5084 26.4576 53.5084 27.9999Z",
    fill: "url(#paint6_linear_552_7076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0084 28.8897L12.8135 26.6948L10.5593 28.8897L12.8135 31.0847L15.0084 28.8897Z",
    fill: "url(#paint7_linear_552_7076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4999 28.8897L43.305 26.6948L41.1101 28.8897L43.305 31.0847L45.4999 28.8897Z",
    fill: "url(#paint8_linear_552_7076)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_552_7076",
    x1: 25.7968,
    y1: 34.4082,
    x2: 33.0663,
    y2: 16.2345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63AE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_552_7076",
    x1: 36.6595,
    y1: 28.892,
    x2: 24.6335,
    y2: 28.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE496",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9362,
    stopColor: "#EFEC53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_552_7076",
    x1: 22.8172,
    y1: 28.8919,
    x2: 33.1894,
    y2: 28.8919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63AE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_552_7076",
    x1: 56,
    y1: 44.9216,
    x2: 15.8181,
    y2: 24.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D63F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DB83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_552_7076",
    x1: 54.5169,
    y1: 24.7161,
    x2: 13.0804,
    y2: 4.34232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D63F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DB83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_552_7076",
    x1: 42.2043,
    y1: 9.70798,
    x2: 5.70155,
    y2: 26.6649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE496",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9362,
    stopColor: "#EFEC53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_552_7076",
    x1: 13.9442,
    y1: 47.6897,
    x2: 49.1525,
    y2: 29.1794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE496",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9362,
    stopColor: "#EFEC53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_552_7076",
    x1: 12.8006,
    y1: 31.0577,
    x2: 12.8006,
    y2: 27.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63AE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_552_7076",
    x1: 43.3117,
    y1: 31.0577,
    x2: 43.3117,
    y2: 27.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63AE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23E0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_552_7076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c1b201f2118a0085fde09f6a91d56737.svg";
export { ForwardRef as ReactComponent };